import { render, staticRenderFns } from "./UpsellListSelector.vue?vue&type=template&id=7f95b0ea&"
import script from "./UpsellListSelector.vue?vue&type=script&lang=js&"
export * from "./UpsellListSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports